/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as StudioRouteImport } from './routes/studio'
import { Route as ReportBugRouteImport } from './routes/report-bug'
import { Route as PluginsRouteImport } from './routes/plugins'
import { Route as FoundingMemberRouteImport } from './routes/founding-member'
import { Route as DesktopRouteImport } from './routes/desktop'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CollaboratorsRouteImport } from './routes/collaborators'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CaseIdRouteImport } from './routes/case.$id'

const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioRoute = StudioRouteImport.update({
  id: '/studio',
  path: '/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportBugRoute = ReportBugRouteImport.update({
  id: '/report-bug',
  path: '/report-bug',
  getParentRoute: () => rootRouteImport,
} as any)
const PluginsRoute = PluginsRouteImport.update({
  id: '/plugins',
  path: '/plugins',
  getParentRoute: () => rootRouteImport,
} as any)
const FoundingMemberRoute = FoundingMemberRouteImport.update({
  id: '/founding-member',
  path: '/founding-member',
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopRoute = DesktopRouteImport.update({
  id: '/desktop',
  path: '/desktop',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CollaboratorsRoute = CollaboratorsRouteImport.update({
  id: '/collaborators',
  path: '/collaborators',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CaseIdRoute = CaseIdRouteImport.update({
  id: '/case/$id',
  path: '/case/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/collaborators': typeof CollaboratorsRoute
  '/contact': typeof ContactRoute
  '/desktop': typeof DesktopRoute
  '/founding-member': typeof FoundingMemberRoute
  '/plugins': typeof PluginsRoute
  '/report-bug': typeof ReportBugRoute
  '/studio': typeof StudioRoute
  '/waitlist': typeof WaitlistRoute
  '/case/$id': typeof CaseIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/collaborators': typeof CollaboratorsRoute
  '/contact': typeof ContactRoute
  '/desktop': typeof DesktopRoute
  '/founding-member': typeof FoundingMemberRoute
  '/plugins': typeof PluginsRoute
  '/report-bug': typeof ReportBugRoute
  '/studio': typeof StudioRoute
  '/waitlist': typeof WaitlistRoute
  '/case/$id': typeof CaseIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/collaborators': typeof CollaboratorsRoute
  '/contact': typeof ContactRoute
  '/desktop': typeof DesktopRoute
  '/founding-member': typeof FoundingMemberRoute
  '/plugins': typeof PluginsRoute
  '/report-bug': typeof ReportBugRoute
  '/studio': typeof StudioRoute
  '/waitlist': typeof WaitlistRoute
  '/case/$id': typeof CaseIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/collaborators'
    | '/contact'
    | '/desktop'
    | '/founding-member'
    | '/plugins'
    | '/report-bug'
    | '/studio'
    | '/waitlist'
    | '/case/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/collaborators'
    | '/contact'
    | '/desktop'
    | '/founding-member'
    | '/plugins'
    | '/report-bug'
    | '/studio'
    | '/waitlist'
    | '/case/$id'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/collaborators'
    | '/contact'
    | '/desktop'
    | '/founding-member'
    | '/plugins'
    | '/report-bug'
    | '/studio'
    | '/waitlist'
    | '/case/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  CollaboratorsRoute: typeof CollaboratorsRoute
  ContactRoute: typeof ContactRoute
  DesktopRoute: typeof DesktopRoute
  FoundingMemberRoute: typeof FoundingMemberRoute
  PluginsRoute: typeof PluginsRoute
  ReportBugRoute: typeof ReportBugRoute
  StudioRoute: typeof StudioRoute
  WaitlistRoute: typeof WaitlistRoute
  CaseIdRoute: typeof CaseIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio': {
      id: '/studio'
      path: '/studio'
      fullPath: '/studio'
      preLoaderRoute: typeof StudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report-bug': {
      id: '/report-bug'
      path: '/report-bug'
      fullPath: '/report-bug'
      preLoaderRoute: typeof ReportBugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plugins': {
      id: '/plugins'
      path: '/plugins'
      fullPath: '/plugins'
      preLoaderRoute: typeof PluginsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/founding-member': {
      id: '/founding-member'
      path: '/founding-member'
      fullPath: '/founding-member'
      preLoaderRoute: typeof FoundingMemberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desktop': {
      id: '/desktop'
      path: '/desktop'
      fullPath: '/desktop'
      preLoaderRoute: typeof DesktopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collaborators': {
      id: '/collaborators'
      path: '/collaborators'
      fullPath: '/collaborators'
      preLoaderRoute: typeof CollaboratorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/case/$id': {
      id: '/case/$id'
      path: '/case/$id'
      fullPath: '/case/$id'
      preLoaderRoute: typeof CaseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  CollaboratorsRoute: CollaboratorsRoute,
  ContactRoute: ContactRoute,
  DesktopRoute: DesktopRoute,
  FoundingMemberRoute: FoundingMemberRoute,
  PluginsRoute: PluginsRoute,
  ReportBugRoute: ReportBugRoute,
  StudioRoute: StudioRoute,
  WaitlistRoute: WaitlistRoute,
  CaseIdRoute: CaseIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
